var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6699 26.1685H16.3366C13.7593 26.1685 11.6699 28.2578 11.6699 30.8351V44.8351C11.6699 47.4125 13.7593 49.5018 16.3366 49.5018H39.6699C42.2473 49.5018 44.3366 47.4125 44.3366 44.8351V30.8351C44.3366 28.2578 42.2473 26.1685 39.6699 26.1685Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6689 26.1657V16.8324C18.6689 14.357 19.6523 11.983 21.4026 10.2327C23.153 8.48235 25.5269 7.49902 28.0023 7.49902C30.4776 7.49902 32.8516 8.48235 34.6019 10.2327C36.3523 11.983 37.3356 14.357 37.3356 16.8324V26.1657",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.e9312913f51d2ec30b504029d2f00a5b.svg";
export { ForwardRef as ReactComponent };